(function ($, w) {
    var container = $.getElementById('headings-scroll-container');
    // Grab all the top level h2 elements
    // Change this to tweak which elements get used as targets/links
    var headings = $.querySelectorAll('article.content h2');
    if (container && headings.length) {
        var mappedHeadings_1 = {};
        // Only generate the menu if we have h2 elements
        headings.forEach(function (heading) {
            var link = $.createElement('a');
            var id = heading.id;
            // If the ID is empty, generate one based on the content
            if (id == '') {
                id = heading.textContent.toLowerCase();
                id = id.replace(' ', '-');
            }
            // If the ID already exists add a random string to the end
            if (mappedHeadings_1.hasOwnProperty(id)) {
                id += '-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
            }
            heading.id = id;
            link.href = '#' + id;
            link.classList.add('link-' + id);
            link.textContent = heading.textContent;
            container.appendChild(link);
            mappedHeadings_1[id] = heading.offsetTop;
        });
        container.style.height = container.offsetHeight + 'px';
        container.style.width = container.offsetWidth + 'px';
        container.classList.add('collapsed');
        container.style.top = 'calc(50% - ' + (container.offsetHeight / 2) + 'px)';
        container.addEventListener('click', function (e) {
            var target = e.target;
            if (target.tagName !== 'A') {
                if (container.classList.contains('collapsed')) {
                    container.classList.remove('collapsed');
                    container.classList.add('open');
                }
                else {
                    container.classList.add('auto-collapsing');
                    container.classList.remove('open');
                    setTimeout(function () {
                        container.classList.add('collapsed');
                        container.classList.remove('auto-collapsing');
                    }, 500);
                }
            }
            else {
                flag = true;
                setActive(target.getAttribute('href').replace('#', ''));
                setTimeout(function () { return (flag = false); }, 2000);
            }
        });
        w.addEventListener('scroll', check, false);
        w.addEventListener('resize', check, false);
        var flag = false;
        function setActive(id) {
            container.querySelectorAll('a').forEach(function (link) {
                if (link.classList.contains('link-' + id)) {
                    link.classList.add('active');
                }
                else {
                    link.classList.remove('active');
                }
            });
        }
        // Checks which element is view and adds the active class to the link
        function check() {
            if (!flag) {
                w.requestAnimationFrame(function () {
                    flag = false;
                    var top = w.scrollY;
                    var deltas = {};
                    var small = 500;
                    for (var i in mappedHeadings_1) {
                        var delta = Math.round(Math.abs(top - mappedHeadings_1[i]));
                        deltas[delta] = i;
                        small = Math.min(small, delta);
                    }
                    setActive(deltas[small]);
                });
            }
            flag = true;
        }
    }
})(document, window);
